import jwtDecode from "jwt-decode";
import { useMemo } from "react";

export const decodeToken = (token: string) => {
  if (!token || token === "undefined") {
    return null;
  }
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken;
  } catch (error) {
    console.error("Erro ao decodificar token:", error);
    return null;
  }
};

export const useDecodedToken = (token?: string) => {
  return useMemo(() => {
    if (!token || token === "undefined") {
      return null;
    }
    try {
      return jwtDecode(token);
    } catch (error) {
      console.error("❌ Erro ao decodificar token:", error);
      return null;
    }
  }, [token]); // Só recalcula quando o token muda
};
